export const UPDATE_METADATA_SUCCESS = 'UPDATE_METADATA_SUCCESS';
export const UPDATE_METADATA_ERROR = 'UPDATE_METADATA_ERROR';
